import React, { FC, useContext } from 'react';

import { Input, PhoneInput } from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import s from '../../../TinkoffModal.module.scss';
import { IFormBlockProps } from '../interfaces';

export const Contacts: FC<IFormBlockProps> = ({ control, setError }) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.form__block}>
      <span className={s.title}>{t('contacts')}</span>
      <Controller
        render={({ field, fieldState: { error } }) => (
          <PhoneInput
            {...field}
            title={t('phone')}
            error={error?.message}
            onBlur={() => {
              if (!field.value && setError) {
                setError('phone', {
                  message: t('errors.required'),
                });
              }
            }}
            disabled
          />
        )}
        name="phone"
        control={control}
        rules={{
          required: t('errors.required'),
          minLength: {
            value: 9,
            message: t('errors.minLength', 9),
          },
          maxLength: {
            value: 14,
            message: t('errors.maxLength', 14),
          },
        }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input {...field} title="E-mail" error={error?.message} />
        )}
        name="email"
        control={control}
        rules={{
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i,
            message: t('errors.email.valid'),
          },
        }}
      />
    </div>
  );
};
